<template>
    <div class="nouvelle-single-wrapper">
        <div class="hero-background eggshell"></div>

        <header class="header-single-news" page-transition-group>
            <HeroNewsSingle v-if="contentIsLoaded" />
        </header>

        <main class="page-content" page-transition-group>
            <article v-if="contentIsLoaded && content.matrixSections.sections">

                <MatrixFields
                    v-for="(element, index) in content.matrixSections.sections"
                    :key="'blog-section-' + index"
                    :matrix="element"
                />

                <div
                    v-if="contentIsLoaded && content.newsSwipper.swipper.length"
                    class="swiper-news-wrapper"
                >
                    <SwiperNews :imgGallery="content.newsSwipper" />
                </div>

                <div v-else>
                    <div class="container-xxl padding-container-sm-top">
                        <div class="row justify-content-center">
                            <div class="col-12">
                                <div class="sep-hor-black-thick"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </article>

            <div v-if="contentIsLoaded" class="container-xxl padding-container-sm-top">
                <div class="row justify-content-between pb-4">
                    <div class="col-12 col-md-6">
                        <h6 class="text-uppercase">{{ $t('Autres nouvelles') }}</h6>
                    </div>

                    <div class="col-12 col-md-6 d-flex justify-content-md-end">
                        <router-link
                            :to="{ name: 'Nouvelles-fr' }"
                            class="link-arrow right bold text-uppercase text-red mb-0"
                            itemtype="https://www.schema.org/SiteNavigationElement"
                        >
                            {{ $t('Voir plus') }}
                        </router-link>
                    </div>
                </div>
            </div>
            <div v-if="contentIsLoaded && content.latestNews" class="container-xxl padding-container-sm-bottom overflow-container">
                <div class="row">
                    <div class="col-12">
                        <SwiperLatestNews :latestNews="content.latestNews.news" />
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapGetters, mapActions } from 'vuex'
import HeroNewsSingle from '@/components/hero/HeroNewsSingle.vue'
import SwiperNews from '@/components/swiper/SwiperNews'
import SwiperLatestNews from '@/components/swiper/SwiperLatestNews'
// import AssetLoader from '@/components/helpers/AssetLoader'

import MatrixFields from '@/components/matrix/matrixFields'

export default {
    name: 'Nouvelle',

    metaInfo() {
        return {
            ...(this.content && this.content.title && { title: this.content.title.replace(/&nbsp;/g, ' ') }),
            ...(this.content && this.content.title &&  { titleTemplate: this.content.title.replace(/&nbsp;/g, ' ') }),

            meta: [
                {
                    vmid: 'og:title',
                    property: 'og:title',
                    content: this.content ? this.content.title.replace(/&nbsp;/g, ' ') : '',
                },

                {
                    vmid: 'description',
                    name: 'description',
                    content: this.content ? this.content.newsExerpt : '',
                },
                {
                    vmid: 'og:description',
                    property: 'og:description',
                    content: this.content ? this.content.newsExerpt : '',
                },
                {
                    vmid: 'og:image',
                    property: 'og:image',
                    content: this.content ? this.content.featuredImage.img.url : '',
                },
                {
                    vmid: 'twitter:image',
                    name: 'twitter:image',
                    content: this.content ? this.content.featuredImage.img.url : '',
                },
                {
                    vmid: 'twitter:title',
                    name: 'twitter:title',
                    content: this.content ? this.content.title.replace(/&nbsp;/g, ' ') : '',
                },
                {
                    vmid: 'twitter:description',
                    name: 'twitter:description',
                    content: this.content ? this.content.newsExerpt : '',
                },
            ],
        }
    },

    components: {
        // AssetLoader,
        HeroNewsSingle,
        SwiperNews,
        MatrixFields,
        SwiperLatestNews,
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },

    methods: {
        ...mapActions(['setErrorsReportMsg']),
    },
}
</script>

<style lang="scss"></style>
